<template>
  <v-container class="grey lighten-5 partnerContainer">
    <v-layout class="ml-4 mt-2" justify-start align-start row>
      <v-icon color="primary" style="font-size: 50px;">border_color</v-icon>
      <h2 :style="`color: ${$vuetify.theme.primary}`" class="mt-2">{{formTitle}}</h2>
    </v-layout>
    <v-layout>
      <v-flex>
        <v-form v-model="partnerFormValid" lazy-validation ref="partnerForm">
          <v-layout>
            <v-flex xs12>
              <h1 class="mt-3">{{$translate('GENERAL')}}</h1>
              <v-card class="v-card--flat">
                <v-layout class="mt-2" row wrap justify-space-around>
                  <v-flex xs5>
                    <h4>{{$translate('PARTNER_NAME')}}</h4>
                    <v-text-field
                      v-model="partner.Name"
                      rows="1"
                      auto-grow
                      class="mb-2"
                      :label="$translate('PARTNER_NAME')"
                      outline
                      required
                    />
                  </v-flex>
                  <v-flex xs5>
                    <h4>{{$translate('PARTNER_ADDRESS')}}</h4>
                    <v-text-field
                      v-model="partner.Address"
                      rows="1"
                      auto-grow
                      class="mb-2"
                      :label="$translate('PARTNER_ADDRESS')"
                      outline
                    />
                  </v-flex>
                  <v-flex xs5>
                    <h4>{{$translate('PARTNER_CITY')}}</h4>
                    <v-text-field
                      v-model="partner.City"
                      rows="1"
                      auto-grow
                      class="mb-2"
                      :label="$translate('PARTNER_CITY')"
                      outline
                    />
                  </v-flex>
                  <v-flex xs5>
                    <h4>{{$translate('PARTNER_POSTAL_CODE')}}</h4>
                    <v-text-field
                      v-model="partner.PostalCode"
                      rows="1"
                      auto-grow
                      class="mb-2"
                      :label="$translate('PARTNER_POSTAL_CODE')"
                      outline
                    />
                  </v-flex>
                  <v-flex xs5>
                    <h4>{{$translate('PARTNER_EMAIL')}}</h4>
                    <v-text-field
                      v-model="partner.Email"
                      rows="1"
                      auto-grow
                      class="mb-2"
                      :label="$translate('PARTNER_EMAIL')"
                      outline
                      required
                    />
                  </v-flex>
                  <v-flex xs5>
                    <h4>{{$translate('ADMINISTRATION_PARTNER_EMAIL')}}</h4>
                    <v-text-field
                      v-model="partner.AdministrationEmail"
                      rows="1"
                      auto-grow
                      class="mb-2"
                      :label="$translate('ADMINISTRATION_PARTNER_EMAIL')"
                      outline
                    />
                  </v-flex>
                  <v-flex xs5>
                    <h4>Partner CoC code (KvK)</h4>
                    <v-text-field
                      v-model.number="partner.COC"
                      rows="1"
                      class="mb-2"
                      label="COC / KVK code"
                      outline
                    />
                  </v-flex>
                  <v-flex xs5 v-if="this.$store.getters['auth/userLevel'] == 9">
                    <h4>{{$translate('PARTNER_LEVEL')}}</h4>
                    <v-select
                      v-model="partner.PartnerLevel"
                      :items="partnerLevels"
                      item-text="Name"
                      item-value="Level"
                      :label="$translate('PARTNER_LEVEL')"
                      outline
                    />
                  </v-flex>
                </v-layout>
              </v-card>
            </v-flex>
          </v-layout>
          <v-layout>
            <v-flex xs12>
              <h1 class="mt-3">External event platform</h1>
              <v-card class="v-card--flat">
                <v-layout v-if="partner.ExternalEventBridges.hasOwnProperty('Formitable')"
                          class="mt-2"
                          row
                          wrap
                          justify-space-around>
                  <v-flex xs5>
                    <h4>Formitable</h4>
                    <v-text-field
                      v-model="partner.ExternalEventBridges.Formitable.ApiKey"
                      rows="1"
                      auto-grow
                      class="mb-2"
                      label="Api key"
                      outline
                      required
                    />
                  </v-flex>
                </v-layout>
                <h4>TicketCounter</h4>
                <v-layout v-if="partner.ExternalEventBridges.hasOwnProperty('TicketCounter')"
                          class="mt-2"
                          row
                          wrap
                          justify-space-around>
                  <v-flex xs5>
                    <v-text-field
                      v-model="partner.ExternalEventBridges.TicketCounter.ClientId"
                      rows="1"
                      auto-grow
                      class="mb-2"
                      label="ClientId"
                      outline
                      required
                    />
                  </v-flex>
                  <v-flex xs5>
                    <v-text-field
                      v-model="partner.ExternalEventBridges.TicketCounter.ClientSecret"
                      rows="1"
                      auto-grow
                      class="mb-2"
                      label="ClientSecret"
                      outline
                      required
                    />
                  </v-flex>
                  <v-flex xs5>
                    <v-text-field
                      v-model="partner.ExternalEventBridges.TicketCounter.Username"
                      rows="1"
                      auto-grow
                      class="mb-2"
                      label="Username"
                      outline
                      required
                    />
                  </v-flex>
                  <v-flex xs5>
                  <v-text-field
                    v-model="partner.ExternalEventBridges.TicketCounter.Password"
                    rows="1"
                    auto-grow
                    class="mb-2"
                    label="Password"
                    outline
                    required
                  />
                </v-flex>
                  <v-flex xs5>
                    <v-text-field
                      v-model="partner.ExternalEventBridges.TicketCounter.RefreshToken"
                      rows="1"
                      auto-grow
                      class="mb-2"
                      label="RefreshToken"
                      outline
                      required
                    />
                  </v-flex>
                </v-layout>
              </v-card>
            </v-flex>
          </v-layout>
          <v-layout>
            <v-flex xs12>
              <h1 class="mt-3">{{$translate('COMMUNICATIONS')}}</h1>
              <v-card class="v-card--flat">
                <v-layout class="mt-2" row wrap justify-space-around>
                  <v-flex xs5>
                    <v-checkbox
                      v-model="partner.NotifyBooked"
                      label="Visitor booked notifications"
                      hide-details
                    ></v-checkbox>
                  </v-flex>
                </v-layout>
              </v-card>
            </v-flex>
          </v-layout>

          <v-layout>
            <v-flex xs12>
              <h1 class="mt-3">{{$translate('Financial')}}</h1>
              <v-card class="v-card--flat">
                <v-layout class="mt-2" row wrap justify-space-around>
                  <v-flex xs5>
                    <h4>{{$translate('PARTNER_IBAN')}}</h4>
                    <v-text-field
                      v-model="partner.IBAN"
                      rows="1"
                      auto-grow
                      class="mb-2"
                      :label="$translate('PARTNER_IBAN')"
                      outline
                    />
                  </v-flex>
                  <v-flex xs5>
                    <h4>Partner VAT number (BTW)</h4>
                    <v-text-field
                      v-model.number="partner.VatNumber"
                      rows="1"
                      class="mb-2"
                      label="VAT number"
                      outline
                    />
                  </v-flex>
                  <v-flex xs5>
                    <h4>{{$translate('PAYMENT_PLATFORM')}}</h4>
                    <v-select
                      :disabled="!partner.PaymentContract"
                      :rules="[ paymentPlatformRule ]"
                      v-model="partner.PaymentPlatform"
                      :items="paymentPlatforms"
                      :label="$translate('PAYMENT_PLATFORM')"
                      outline
                    />
                  </v-flex>
                  <v-flex xs5>
                    <v-checkbox
                      v-model="partner.PaymentContract"
                      :label="$translate('PAYMENT_CONTRACT')"
                      hide-details
                    ></v-checkbox>
                  </v-flex>
                </v-layout>
              </v-card>
            </v-flex>
          </v-layout>

          <v-layout class="mt-4" row wrap justify-space-around>


            <v-flex xs5 v-if="this.$store.getters['auth/userLevel'] == 9">
              <h4>{{$translate('PARTNER_TYPE')}}</h4>
              <v-select
                v-model="partner.Type"
                :items="partnerTypes"
                :label="$translate('PARTNER_TYPE')"
                outline
              />
            </v-flex>
            <v-flex xs5 v-if="this.$store.getters['auth/userLevel'] == 9">
              <h4>{{$translate('SERVICE_PRICE_PERCENTAGE')}}</h4>
              <v-text-field
                v-model.number="partner.ServicePrice"
                rows="1"
                auto-grow
                class="mb-2"
                :label="$translate('SERVICE_PRICE_PERCENTAGE')"
                outline
                type="number"
                min="0"
                max="100"
                prefix="%"
              />
            </v-flex>
<!--            <v-flex xs5>-->
<!--              <h4>Campaign Budget</h4>-->
<!--              <v-text-field-->
<!--                v-model.number="partner.CampaignBudget"-->
<!--                rows="1"-->
<!--                auto-grow-->
<!--                class="mb-2"-->
<!--                label="Campaign Budget"-->
<!--                outline-->
<!--                type="number"-->
<!--                min="0"-->
<!--                prefix="€"-->
<!--              />-->
<!--            </v-flex>-->
            <v-flex xs5 v-if="this.$store.getters['auth/userLevel'] == 9">
              <h4>{{$translate('SERVICE_MINIMUM_PRICE')}}</h4>
              <v-text-field
                v-model.number="partner.MinimumServicePrice"
                rows="1"
                auto-grow
                class="mb-2"
                :label="$translate('SERVICE_MINIMUM_PRICE')"
                outline
                type="number"
                min="0"
                prefix="€"
              />
            </v-flex>
            <v-flex xs5 v-if="this.$store.getters['auth/userLevel'] == 9">
              <h4>Partner Supplier Code</h4>
              <v-text-field
                v-model.number="partner.SupplierCode"
                rows="1"
                class="mb-2"
                label="Supplier code"
                outline
              />
            </v-flex>
          </v-layout>
          <v-layout row justify-space-around pb-3>
            <v-flex xs4>
              <v-checkbox
                v-model="partner.NotifyArrived"
                label="Visitor arrival notifications"
                hide-details
              ></v-checkbox>
            </v-flex>
            <v-flex xs4>
              <v-checkbox
                v-model="partner.PlanningContract"
                :label="$translate('PLANNING_CONTRACT')"
                hide-details
              ></v-checkbox>
            </v-flex>
            <v-flex xs4>
              <v-checkbox
                v-model="partner.DirectDebit"
                :label="$translate('DIRECT_DEBIT')"
                hide-details
              ></v-checkbox>
              <v-layout row>
                <v-flex xs1>
                  <v-checkbox
                    v-model="partner.TermsAccepted"
                    hide-details
                  ></v-checkbox>
                </v-flex>
                <v-flex xs11 style="padding-top: 1.7em;">
                  <p>{{$translate('TERMS_ACCEPT')}}
                    <a target="_blank" href="https://www.superlinda.nl/algemene-voorwaarden-partners">
                      {{$translate('TICKET_TEXT_TERMS')}}
                    </a>
                  </p>
                </v-flex>
              </v-layout>
            </v-flex>
          </v-layout>
        </v-form>
      </v-flex>
    </v-layout>
    <v-layout class="mt-4 mb-4 pb-4" row wrap justify-space-between>
      <v-spacer></v-spacer>
      <v-flex class="pl-4 pr-4" xs2>
        <v-btn color="primary" :disabled="!partner.TermsAccepted" round block @click="saveNewPartner">{{ $translate('SAVE') }}</v-btn>
      </v-flex>
    </v-layout>
  </v-container>
</template>
<script>
  import * as dssRequest from "@/api/dssRequest";
  import PartnerObject from "@/objects/PartnerObject";
  import { store } from "../store";
export default {
  watch: {
    },
    data() {
      return {
        partnerTypes: [],
        partnerLevels: [
          {Level: 1, Name: 'Registerd'},
          {Level: 2, Name: 'Basic'},
          {Level: 3, Name: 'Premium'},
        ],
        types: [
          "FlexEvent",
          "Fixed",
          'Repetitive',
          "Theme",
          "Tour",
          "Relay",
          "Rental",
          "OrderEvent",
          "Complimentary Service",
        ],
        // partner
        partner: PartnerObject._objectDefinition(),
        //payment
        paymentPlatforms: ["Mollie", "Global Ticket"],
      };
    },
    created() {
      this.getUserData();
    },
    beforeDestroy() {

    },
    mounted() {

    },
    methods: {
      paymentPlatformRule(v) {
        if (!!v) {
          return true;
        } else if (!this.partner.PaymentContract) {
          return true;
        } else {
          return "A payment platform for the partner is required";
        }
      },
      getUserData() {
        const payload = {
          RelationType: "User",
          Id: store.getters["auth/userName"],
          Types: {
            User: "User"
          },
          StructuredReply: true
        };
        dssRequest.doRequest(
          response => {
            console.log("The call for getUserData was successful", response);
          },
          error => {
            console.log("The call for getUserData was not successful", error);
          },
          "getUserData",
          this.$store.getters["auth/userName"],
          payload,
          600000,
          false
        );
      },
      saveNewPartner() {
        // Action for clicking on the SAVE button in the Partner details dialog
        if (this.$refs.partnerForm.validate()) {
          if (!this.partner.SupplierCode) {
            this.partner.SupplierCode = "";
          }
          if (!this.partner.VatNumber) {
            this.partner.VatNumber = "";
          }
          if (!this.partner.COC) {
            this.partner.COC = "";
          }
          console.log("Lorenzo haal ik dit", );
          const payload = Object.assign({}, this.partner);
          let requestId = this.editMode ? "editPartner" : "createPartner";
          dssRequest.doRequest(
            response => {
              console.log(
                "the call for " + requestId + " was successful",
                response
              );
              this.partner.PartnerId = Number(response.data.PartnerId);
              // this.close();
              // this.getPartners();
              window.EventBus.fire("goToHome",{});
            },
            error => {
              console.log(
                "the call for " + requestId + " was not successful",
                error
              );
              // if (error.hasOwnProperty('errorMsg') && error.errorMsg.includes('E_OB_033')) {
              //   this.doublePartnerDialog = true;
              // }
            },
            requestId,
            this.$store.getters.getCurrentAccountId,
            payload,
            600000,
            false
          );
        }
      },
    }
  };
</script>
<style lang="scss" scoped>
  .partnerContainer {
    width: 1000px;
    margin-bottom: 5em !important;
    margin-top: 5em !important;
  }
</style>
